
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/todays-deals",
      function () {
        return require("private-next-pages/todays-deals/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/todays-deals"])
      });
    }
  